<template> <!-- OK -->
  <div class="stage-management">
    <h2>Gerenciamento de Etapas</h2>
    <button @click="goBack" class="back-button">Voltar a Administração</button>
    <div class="form-container">
      <form @submit.prevent="createStage">
        <div class="form-group">
          <label for="name">Nome da Etapa:</label>
          <input v-model="newStage.name" required>
        </div>
        <div class="form-group">
          <label for="startDate">Data de Início:</label>
          <input type="date" v-model="newStage.startDate" required>
        </div>
        <div class="form-group">
          <label for="endDate">Data de Fim:</label>
          <input type="date" v-model="newStage.endDate" required>
        </div>
        <button type="submit" class="create-button">Criar Etapa</button>
      </form>
    </div>
    <div class="error-message" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="stage-list">
      <ul>
        <li v-for="stage in stages" :key="stage.id" class="stage-item">
          <div class="stage-info">
            <span class="stage-name">{{ stage.name }}</span>
            <span class="stage-dates">({{ formatDate(stage.startDate) }} - {{ formatDate(stage.endDate) }})</span>
          </div>
          <div class="stage-actions">
            <button @click="confirmDeleteStage(stage.id)" class="delete-button">Deletar</button>
            <button @click="confirmEndStage(stage.id)" class="end-stage-button">Encerrar</button>
            <button @click="editStage(stage)" class="edit-button">Editar</button>
          </div>
        </li>
      </ul>
    </div>

    <div v-if="showEditModal" class="modal">
      <div class="modal-content">
        <h3>Editar Etapa</h3>
        <div class="form-group">
          <label>Nome:</label>
          <input v-model="editingStage.name" required>
        </div>
        <div class="form-group">
          <label>Data de Início:</label>
          <input type="date" v-model="editingStage.startDate" required>
        </div>
        <div class="form-group">
          <label>Data de Fim:</label>
          <input type="date" v-model="editingStage.endDate" required>
        </div>
        <button @click="confirmEditStage" class="confirm-button">Salvar</button>
        <button @click="closeEditModal" class="cancel-button">Cancelar</button>
      </div>
    </div>

    <div v-if="showConfirmEditModal" class="modal">
      <div class="modal-content">
        <p>Tem certeza que deseja salvar as alterações?</p>
        <button @click="saveEditStage" class="confirm-button">Confirmar</button>
        <button @click="closeConfirmEditModal" class="cancel-button">Cancelar</button>
      </div>

    </div>

    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <p>{{ modalMessage }}</p>
        <button @click="confirmAction" class="confirm-button">Confirmar</button>
        <button @click="cancelAction" class="cancel-button">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import stageService from '../services/stageService';

export default {
  name: 'StageManagement',
  data() {
    return {
      newStage: {
        name: '',
        startDate: '',
        endDate: ''
      },
      stages: [],
      errorMessage: '',
      showModal: false,
      modalMessage: '',
      actionToConfirm: null,
      actionData: null,
      showEditModal: false,
      showConfirmEditModal: false,
      editingStage: {
        id: null,
        name: '',
        startDate: '',
        endDate: ''
      }
    };
  },
  methods: {
    async createStage() {
      try {
        await stageService.createStage(this.newStage);
        await this.fetchStages();
        this.clearErrorMessage();
      } catch (error) {
        this.errorMessage = 'Erro ao criar etapa';
        console.error('Erro ao criar etapa', error);
      }
    },
    async fetchStages() {
      try {
        const response = await stageService.getAllStages();
        this.stages = response.data;
      } catch (error) {
        this.errorMessage = 'Erro ao buscar etapas';
        console.error('Erro ao buscar etapas', error);
      }
    },
    async deleteStage(stageId) {
      try {
        await stageService.deleteStage(stageId);
        await this.fetchStages();
        this.clearErrorMessage();
      } catch (error) {
        this.errorMessage = 'Erro ao deletar etapa';
        console.error('Erro ao deletar etapa', error);
      }
    },
    async endStage(stageId) {
      try {
        await stageService.endStage(stageId);
        alert('Etapa encerrada com sucesso');
        await this.fetchStages();
        this.clearErrorMessage();
      } catch (error) {
        this.errorMessage = 'Erro ao encerrar etapa';
        console.error('Erro ao encerrar etapa', error);
      }
    },
    goBack() {
      this.$router.push('/admin');
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric', timeZone:'UTC' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
    clearErrorMessage() {
      this.errorMessage = '';
    },
    editStage(stage) {
      this.editingStage = { ...stage };
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    confirmEditStage() {
      this.showEditModal = false;
      this.showConfirmEditModal = true;
    },
    closeConfirmEditModal() {
      this.showConfirmEditModal = false;
    },
    async saveEditStage() {
      try{
        await stageService.updateStage(this.editingStage.id, this.editingStage);
        this.showConfirmEditModal = false;
        await this.fetchStages();
      }catch(error){
        console.error('Erro ao editar etapa', error);
        this.errorMessage = 'Erro ao editar etapa';
      }
    },
    confirmDeleteStage(stageId){
      this.showModal = true;
      this.modalMessage = 'Tem certeza que deseja excluir esta etapa?';
      this.actionToConfirm = this.deleteStage;
      this.actionData = stageId;
    },
    confirmEndStage(stageId){
      this.showModal = true;
      this.modalMessage = 'Tem certeza que deseja encerrar esta etapa?';
      this.actionToConfirm = this.endStage;
      this.actionData = stageId;
    },
    confirmAction(){
      if (this.actionToConfirm) {
        this.actionToConfirm(this.actionData);
      }
      this.showModal = false;
    },
    cancelAction(){
      this.showModal = false;
    }
  },
  created() {
    this.fetchStages();
  }
};
</script>

<style scoped>
.stage-management {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: #f0f4f7;
  padding: 2rem;
}

.stage-management h2 {
  margin-bottom: 2rem;
  color: #003366;
  font-size: 2rem;
  text-align: center;
}

.back-button {
  text-decoration: none;
  color: white;
  background-color: #0056b3;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-bottom: 1rem;
}

.back-button:hover {
  background-color: #003366;
}

.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
}

.form-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.form-group label {
  font-size: 1rem;
  color: #003366;
  margin-bottom: 0.5rem;
}

.form-group input {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.create-button {
  text-decoration: none;
  color: white;
  background-color: #28a745;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  font-size: 1rem;
  transition: background-color 0.3s;
  margin-top: 1rem;
  width: 100%;
}

.create-button:hover {
  background-color: #218838;
}

.stage-list {
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.stage-list ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.stage-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
  border-bottom: 1px solid #ddd;
}

.stage-item:last-child {
  border-bottom: none;
}

.stage-info {
  display: flex;
  flex-direction: column;
}

.stage-name {
  font-weight: bold;
  color: #003366;
}

.stage-dates {
  font-size: 0.9rem;
  color: #666;
}

.stage-actions {
  display: flex;
  gap: 0.5rem;
}

.delete-button, .end-stage-button, .edit-button {
  background-color: #e74c3c;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.delete-button:hover, .end-stage-button:hover, .edit-button:hover {
  background-color: #c0392b;
}

.error-message {
  color: #e74c3c;
  margin-bottom: 1rem;
  font-size: 1rem;
  text-align: center;
}

.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content{
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  text-align: center;
}

.confirm-button {
  background-color: #28a745;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.confirm-button:hover{
  background-color: #218838;
}

.cancel-button{
  background-color: #e74c3c;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.cancel-button:hover{
  background-color: #c0392b;
}

@media (max-width: 768px) {
  .form-container {
    padding: 1rem;
  }

  .form-group input {
    font-size: 0.9rem;
  }

  .create-button {
    font-size: 0.9rem;
  }

  .stage-list {
    padding: 0.5rem;
  }

  .stage-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .stage-actions {
    width: 100%;
    justify-content: flex-end;
    margin-top: 0.5rem;
  }

  .delete-button, .end-stage-button, .edit-button {
    width: 48%;
    text-align: center;
  }
}

@media (max-width: 425px) {
  .form-container {
    padding: 0.5rem;
  }

  .form-group label {
    font-size: 0.8rem;
  }

  .form-group input {
    font-size: 0.8rem;
    padding: 0.4rem;
  }

  .create-button {
    font-size: 0.8rem;
    padding: 0.4rem;
  }

  .stage-list {
    padding: 0.5rem;
  }

  .stage-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .stage-actions {
    width: 100%;
    justify-content: flex-end;
    margin-top: 0.5rem;
  }

  .delete-button, .end-stage-button, .edit-button {
    width: 48%;
    text-align: center;
  }
}
</style>
